import { io } from 'socket.io-client';
import API_URL from '../apiconfig';

export const socket = io(API_URL, {
  transports: ['websocket', 'polling'], // use WebSocket first, if available
});
